module.exports = __webpack_public_path__ + "b444efa458a20cf4e9a1cc28ed8d3d56.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/friends.jpg
 ** module id = 193
 ** module chunks = 0
 **/